const INITIAL_STATE = {
    registro: {},
    aguardando: false,
    modoTela: "lista",
    lista: [],
    listaCliente: [],
    listaUnidadeConsumidora: [],
    listaGrupoContratoAluguel: [],
    listaTipoCustoGestaoContratoAluguel: [],
    filtro: {
        id_cliente: null,
        id_unidade_consumidora: null,
    },
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "CONTRATO_ALUGUEL_MODO_TELA":
            return { ...state, modoTela: action.payload.modo, registro: action.payload.registro };

        case "CONTRATO_ALUGUEL_SET_AGUARDANDO":
            return { ...state, aguardando: action.payload };

        case "CONTRATO_ALUGUEL_FILTRO":
            return { ...state, filtro: action.payload };

        case "CONTRATO_ALUGUEL_LISTADO":
            return {
                ...state,
                lista: action.payload.data,
            };

        case "GRUPO_CONTRATO_ALUGUEL_LISTADO":
            return {
                ...state,
                listaGrupoContratoAluguel: action.payload.data,
            };

        case "CONTRATO_ALUGUEL_CLIENTE_SELECT_LISTADO":
            return {
                ...state,
                listaCliente: action.payload.data,
            };

        case "CONTRATO_ALUGUEL_UNIDADE_CONSUMIDORA_SELECT_LISTADO":
            return {
                ...state,
                listaUnidadeConsumidora: action.payload.data,
            };
        case "CONTRATO_ALUGUEL_TIPO_CUSTO_GESTAO_SELECT_LISTADO":
            return {
                ...state,
                listaTipoCustoGestaoContratoAluguel: action.payload.data,
            };

        default:
            return state;
    }
};
